/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IPostleitzahlzuordnungDisplayModel {
  bundesland?: null | string;
  id?: null | string;
  name?: null | string;
  ort?: null | string;
  postleitzahl?: null | string;
}
export class PostleitzahlzuordnungDisplayModel extends BaseModel implements IPostleitzahlzuordnungDisplayModel {
  bundesland?: null | string;
  id?: null | string;
  name?: null | string;
  ort?: null | string;
  postleitzahl?: null | string;
}
class BasePostleitzahlzuordnungDisplayModelFormGroup extends FormGroup {
  private static _instance: PostleitzahlzuordnungDisplayModelFormGroup;
  
  public static get Instance(): PostleitzahlzuordnungDisplayModelFormGroup {
    this._instance = new PostleitzahlzuordnungDisplayModelFormGroup({
      bundesland: new FormControl(null),
      id: new FormControl(null),
      name: new FormControl(null),
      ort: new FormControl(null),
      postleitzahl: new FormControl(null),
    });

    return this._instance;
  }
}


export class PostleitzahlzuordnungDisplayModelFormGroup extends BasePostleitzahlzuordnungDisplayModelFormGroup {
  public get Bundesland(): FormControl {
    return this.controls["bundesland"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get Ort(): FormControl {
    return this.controls["ort"] as FormControl;
  }
  public get Postleitzahl(): FormControl {
    return this.controls["postleitzahl"] as FormControl;
  }
  

}

export module PostleitzahlzuordnungDisplayModelForm
  {
    export class FormFields
    {
      static _bundesland: string = "bundesland";
      static _id: string = "id";
      static _name: string = "name";
      static _ort: string = "ort";
      static _postleitzahl: string = "postleitzahl";
    }
  }

